import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Row, Col, FloatingLabel, Container, Alert } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import LicService from '../../../../../services/licitacao-auth';



const FormArquivo = () => {
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [ano, setAno] = useState("");
    const [anexo, setAnexo] = useState("");
    const [anexos, setAnexos] = useState([])
    const [documentos, setDocumentos] = useState([])
    const [sit, setSit] = useState("");
    const [processo, setProcesso] = useState("");


    async function pegaAno(id) {
        const response = await LicService.licEdit(id);
        defineSituacao(response.data["situacao"])
        setAno(response.data["ano"]);
        setProcesso(response.data["processo"]);
        setAnexos(response.data["anexos"]);
    }

    const defineSituacao = (situacao) => {
            switch (situacao) {
                case "Em Andamento":
                    setSit("andamento")
                    break;
                case "Publicada":
                    setSit("avisos")
                    break;
                case "Homologada":
                case "Cancelada":
                    setSit("encerradas")
                    break;
                default:
                    setSit("todas")
                    break;
            }
    }

    useEffect(() => {
        pegaAno(id)
    }, [])

    const { id } = useParams();
    const montaForm = async () => {
        const lic = new FormData();
        for (let i = 0; i < documentos.length; i++) {
            lic.append('anexos', documentos[i]);
        }
        lic.append("ano", ano);
        lic.append("anexo", anexo);
        lic.append("processo", processo);
        return lic
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lic = await LicService.arquivo(id, ano, processo, dados)
            if (lic.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no anexo!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const handleUploadDocumentos = (event) => {
        const files = event.target.files;
        setDocumentos(files);
    };

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="Anexo">
                                        <FloatingLabel
                                            label="Qual anexo?"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="Anexo"
                                                name="anexo"
                                                onChange={e => setAnexo(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                <option value="Novos Anexos">Novos Anexos</option>
                                                {anexos.length > 0 ? (
                                                    anexos.map((anex) =>
                                                        <option key={anex.nomeAnexo} value={anex.nomeAnexo}>{anex.nomeAnexo}</option>
                                                    )
                                                ) : ('')}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {anexo ?
                                    <Col lg={12}>
                                        <Form.Group className="mb-3" controlId="arquivo">
                                            <Form.Label>{anexo}</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="documentos"
                                                onChange={handleUploadDocumentos}
                                                accept=".pdf, .xlsx, .xls"
                                                multiple // Permite múltiplos arquivos
                                            />
                                        </Form.Group>
                                    </Col> : ''}
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                        <Link to={`/restrito/licitacao/listar/${sit}`}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Licitação editada com sucesso!</Alert>
                <Link to={`/restrito/licitacao/listar/${sit}`}>
                    <Button variant="primary" type="button">
                        Ir para Listagens de Licitações {sit}
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default FormArquivo